import {
    ButtonProps,
    Group,
    Text,
    Stack,
    Card,
    Badge
} from "@mantine/core";

import {
    Field,
    Form,
    Formik
} from 'formik';
import {
    FlexiButton,
    FormikTextInput,
    PlatformFieldset
} from "@flexinet/ui-components";
import {ConfirmSubscriptionFormRecordSchema} from "./RecordSchema";
import {useConfirmSubscriptionForm} from "../hooks/useConfirmSubscriptionForm";
import {useNavigate} from "react-router-dom";

const CancelButton = (props: ButtonProps & { type: "button" | "submit" | "reset" | undefined; onClick?: () => void }) =>
    <FlexiButton {...props}>Cancel</FlexiButton>
const RegisterButton = (props: ButtonProps & { type: "button" | "submit" | "reset" | undefined }) =>
    <FlexiButton {...props} />

export const ConfirmSubscriptionForm = () => {
    const navigate = useNavigate();

    const {
        initialValues,
        handleSubmit,
        hasSelectedProduct,
        product,
        customerType
    } = useConfirmSubscriptionForm()
    
    const handleCancel = () => {
        navigate('/products');
    };

    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={ConfirmSubscriptionFormRecordSchema}
                onSubmit={handleSubmit}
            >
                {({
                      isSubmitting,
                  }) => (

                    <Form>
                        <PlatformFieldset legend={'Confirm Subscription'}
                                          px={'xl'}
                                          mb={'xl'}>

                            {customerType === 'marketplace' && (
                                <Badge color="blue" variant="light" mb="md">
                                    Marketplace Customer - Payment handled by marketplace
                                </Badge>
                            )}
                            
                            {customerType === 'direct' && (
                                <Badge color="green" variant="light" mb="md">
                                    Direct Customer - Stripe Payment
                                </Badge>
                            )}

                            {hasSelectedProduct && product ? (
                                <Stack gap="md" mb="lg">
                                    <Card withBorder p="md">
                                        <Text size="lg" fw={600} mb="xs">{(product as any).name}</Text>
                                        {(product as any).shortDescription && (
                                            <Text size="sm" c="dimmed" mb="md">{(product as any).shortDescription}</Text>
                                        )}
                                        {(product as any).prices?.items && (product as any).prices.items.length > 0 && (
                                            <Group gap="xs">
                                                <Text size="sm" fw={500}>Price:</Text>
                                                <Badge variant="light">
                                                    ${(product as any).prices.items[0].amount} / {(product as any).prices.items[0].billingPeriod}
                                                </Badge>
                                            </Group>
                                        )}
                                        {(product as any).freeTrial && (
                                            <Badge color="green" variant="light" mt="xs">Free Trial Available</Badge>
                                        )}
                                    </Card>
                                    <Field
                                        name={'quantity'}
                                        label={'Quantity'}
                                        description={<Text size={'0.8em'} fw={500}>Number of licenses/seats</Text>}
                                        my={'lg'}
                                        component={FormikTextInput}
                                    />
                                </Stack>
                            ) : (
                                <>
                                    <Field
                                        name={'price'}
                                        label={'Price'}
                                        description={<Text size={'0.8em'} fw={500}>i.e. $10</Text>}
                                        my={'lg'}
                                        component={FormikTextInput}
                                    />
                                    <Field
                                        name={'quantity'}
                                        label={'Quantity'}
                                        description={<Text size={'0.8em'} fw={500}>i.e. 1</Text>}
                                        my={'lg'}
                                        component={FormikTextInput}
                                    />
                                </>
                            )}

                            <Group justify={'flex-end'}>
                                <CancelButton type={'button'} variant={'subtle'} onClick={handleCancel}/>
                                <RegisterButton variant={'filled'} disabled={isSubmitting}
                                                type={'submit'}>Confirm</RegisterButton>
                            </Group>
                        </PlatformFieldset>

                    </Form>

                )}
            </Formik>
        </div>
    )
};